import { computed, Signal, WritableSignal } from '@angular/core';
import { Security } from '@shared/models/security';
import { SecurityTaxResultItemReview } from './security-tax-result-item-review';

export class AccordionSecurityReview {
  title!: string;
  security!: Security;
  securityTaxResultItems!: SecurityTaxResultItemReview[];
  isExpanded!: boolean;
  comment!: WritableSignal<string>;
  adminComment?: WritableSignal<string>;
  initialComment!: string;
  initialAdminComment?: string;

  commentHasChanges: Signal<boolean> = computed(() => {
    return this.comment() !== this.initialComment;
  });

  adminCommentHasChanges: Signal<boolean> = computed(() => {
    return (this.adminComment?.() ?? '') !== (this.initialAdminComment ?? '');
  });

  hasErrors: Signal<boolean> = computed((): boolean => {
    return this.securityTaxResultItems.some(securityTaxResultItem =>
      securityTaxResultItem.hasErrors()
    );
  });

  hasChanges: Signal<boolean> = computed((): boolean => {
    return !!(
      this.commentHasChanges() ||
      this.adminCommentHasChanges() ||
      this.securityTaxResultItems.some(securityTaxResultItem =>
        securityTaxResultItem.hasChanges()
      )
    );
  });
}
